/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { ILoyaltyAutoEnrollViewProps } from './loyalty-auto-enroll';

export default (props: ILoyaltyAutoEnrollViewProps) => {
    return (
        <div className={props.errorMessage || props.shouldRedirect || props.showRedirectModal ? 'redirect-modal' : 'redirect-modal-hidden'}>
            <div className='redirect-modal-container'>
                {!props.errorMessage ? (
                    <div className='redirect-modal-content'>
                        <p className='redirect-modal-text'>
                            {props.config.redirectingModalText ?? 'Your profile is incomplete. Please update the following form.'}
                        </p>
                        <p className='redirect-modal-text'>{'Redirecting now—please wait.'}</p>
                    </div>
                ) : (
                    <div className='redirect-modal-content'>
                        <p className='redirect-modal-text' style={{ marginBottom: '10px' }}>
                            {props.errorMessage}
                        </p>
                        <p className='redirect-modal-text'>Try refreshing the page or contact us below.</p>
                        <a
                            href={props.config.contactUsUrl?.destinationUrl ?? 'https://sndlecommregr.dynamics365commerce.ms/contact-us'}
                            className='modal-buttons'
                        >
                            <button className='modal-btn contact-us-btn'>Contact Us</button>
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};
